import { ITimeoutService } from 'angular';
import { Action } from '../../common/actions/core/action';
import ActionDispatcherService from '../../common/actions/core/action-dispatcher.service';
import { ActionHandler } from '../../common/actions/core/action-handler';
import { masterAddressUpdateDialogAction } from './master-address-update-dialog.action';
import { IWindowService } from 'angular';
import FamilyPlanService from '../famil-plan.service';
import { FamilyPlanMemberType } from '../family-plan.model';

/* @ngInject */
export default class ManageContactsDeleteDialogController implements ActionHandler {
  private dialogElement;
  public updatedAddress: any;
  public memberType: FamilyPlanMemberType;

  // protected card: PaymentMethod;
  // protected onDeleteSuccess: (paymentMethodID) => any;

  constructor(
    private $element,
    private $state,
    private actionDispatcher: ActionDispatcherService,
    private $timeout: ITimeoutService,
    private $window: IWindowService,
    private familyPlanService: FamilyPlanService
  ) {
    this.actionDispatcher.register(this);
  }

  public $onInit() {
  }

  public $postLink() {
    this.dialogElement = this.$element.find('#master-address-update-dialog').remodal();
  }

  public $onDestroy() {
    this.actionDispatcher.unregister(this);
    this.dialogElement.destroy();
  }

  public handle(action: Action) {
    if (action instanceof masterAddressUpdateDialogAction) {
      this.updatedAddress = action.address;
      this.memberType = action.type;
      this.openDialog();
    }
  }

  public onClick() {
    this.close();
  }

  private openDialog() {
    this.$timeout(() => {
      this.dialogElement.open();
    });
  }

  public addressUpdateConfirm() {
    if (this.memberType == FamilyPlanMemberType.MASTER) {
      this.familyPlanService.addressUpdate(this.updatedAddress).then(result => {
        this.close();
        this.$state.reload();
      });
    } else {
      this.familyPlanService.approveUpdate(this.updatedAddress).then(result => {
        this.close();
        this.$state.reload();
      });
    }

  }

  public isActive(destination: string) {
    return destination === this.$window.location.pathname;
  }

  private close() {
    this.dialogElement.close();
  }

  public onClose() {
    this.close();
    this.$state.reload();
  }
}



// WEBPACK FOOTER //
// ./src/app/family-plan/master-address-update-dialog/master-address-update-dialog.controller.ts